import React from 'react';
import ReactDOM from 'react-dom/client';
import ChatInterfaceEmbedded from './components/ChatInterfaceEmbedded';
import '../nnaico.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChatInterfaceEmbedded />
  </React.StrictMode>
);
